import toast from 'react-hot-toast';

// 시작일과 종료일 사이의 월 수 계산
export const calculateMonthsDifference = (
  startDate: string,
  endDate: string
) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const months =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth());
  return months;
};

// 종료일을 12개월 이내로 조정하는 함수
export const adjustEndDate = (startDate: string) => {
  const start = new Date(startDate);
  const adjustedEndDate = new Date(start);
  adjustedEndDate.setMonth(start.getMonth() + 12); // 시작일 기준 12개월 후
  adjustedEndDate.setDate(0); // 12개월 후의 마지막 날로 설정
  return adjustedEndDate;
};

// 날짜 범위가 유효한지 체크하는 함수
export const isValidRange = (startDate: string, endDate: string) => {
  if (new Date(startDate) > new Date(endDate)) {
    toast.error('날짜범위 제한을 넘어섰습니다');
    return false;
  }
  return true;
};
